<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    okText="导入"
    @cancel="handleCancel"
    cancelText="关闭">
      <a-form :form="form">
        <a-row>
          <a-col :span="24">
            <a-form-item label="保险公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag
                placeholder="请选择保险公司"
                v-decorator="['companyNumber',validatorRules.companyNumber]"
                :trigger-change="true"
                dict="biz_insurance_company,name,code">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="期数" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input placeholder="请录入期数" v-decorator="['phase',validatorRules.phase]"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="文件" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!--<input type="file" placeholder="请选择文件" v-model="file"/>-->
              <a-upload :file-list="fileList" :multiple="false" :remove="handleRemove" :before-upload="beforeUpload">
                <a-button> <a-icon type="upload" /> 选择文件 </a-button>
              </a-upload>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
  </j-modal>
</template>

<script>
  import { uploadAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import JSearchSelectTag from "@/components/dict/JSearchSelectTag"

  export default {
    name: 'BizInsuranceDataImportModal',
    components: {
      JSearchSelectTag
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {companyNumber:'', phase:''},
        validatorRules: {
          companyNumber: {
            rules: [
              { required: true, message: '请选择保险公司!'},
            ]
          },
          phase:{
            rules: [
              { required: true, message: '请输入期数!'},
            ]
          }
        },

        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        fileList:[],
        title:'导入文件',
        width:800,
        visible: false,
        modalDisable:false,
      }
    },
    methods: {
      show(){
        this.form.setFieldsValue(pick(this.model,'companyNumber','phase'))
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },

      handleCancel () {
        this.close()
      },

      handleOk () {
        const that = this;
        if(this.fileList.length === 0){
          this.$message.warning("请选择文件")
          return;
        }
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            //上传文件
            that.uploadFile(values);
          }
        })
      },

      handleRemove(file) {
        const index = this.fileList.indexOf(file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList;
      },
      beforeUpload(file) {
        this.fileList = [...this.fileList, file];
        return false;
      },

      uploadFile(params) {
        const { fileList } = this;
        const formData = new FormData();
        formData.append('file', fileList[0]);
        formData.append('companyNumber', params.companyNumber);
        formData.append("phase",params.phase);
        this.fileList = [];
        uploadAction(window._CONFIG['domianURL']+"/bms/bizInsuranceData/importExcel", formData).then((res) => {
          if (res.success) {
            this.$message.success(res.result);
            setTimeout(()=>{
              this.visible = false;
              this.$emit('ok');
            },1000)
          }
          else{
            this.modalDisable = false;
            this.$message.error(res.message);
          }
        })
      }
    }
  }
</script>